import type {Converter, ConverterArguments, XConverterKey} from '../types'
import {getLeftColumnsWidth, getLeftMarginInPx, getParentWidth, getRightMarginInPx} from '../utils'
import type {GridItemLayout} from '@wix/document-services-types'
import {convertWidthToPx} from './width'

const justifySelfToPx = (converterArguments: ConverterArguments) => {
    const {measurementsMapAPI, compRef, value} = converterArguments
    const {get} = measurementsMapAPI

    let x = 0

    const {justifySelf, margins} = value as GridItemLayout
    switch (justifySelf) {
        case 'center': {
            const parentWidth = getParentWidth(converterArguments)
            x = parentWidth / 2 - get.width(compRef) / 2
            x += getLeftMarginInPx(converterArguments, convertWidthToPx, margins) / 2
            x -= getRightMarginInPx(converterArguments, convertWidthToPx, margins) / 2
            break
        }
        case 'end': {
            const parentWidth = getParentWidth(converterArguments)
            x = parentWidth - get.width(compRef)
            x -= getRightMarginInPx(converterArguments, convertWidthToPx, margins)
            break
        }
        case 'start':
        case 'stretch':
        default:
            x = getLeftMarginInPx(converterArguments, convertWidthToPx, margins)
    }

    // TODO: should x be relative to the parent or to the column?
    // in Studio it's column, but measurements are relative to parent
    const leftColumnsWidth = getLeftColumnsWidth(converterArguments)
    x += leftColumnsWidth

    return x
}

export const convertXToPx: Record<XConverterKey, Converter> = {
    justifySelf: justifySelfToPx
}
